<template>
  <div class="topbar-wrapper">
    <div class="topbar-item">
      <div class="inline">
        <span class="context-title">{{ $t('app.topbar.organisations') }}</span>
        <ContextHandler contextType="organisation" />
      </div>
      <div v-if="!!appStore.currentSpaceId" class="inline">
        <span class="context-separator">|</span>
        <span class="context-title">{{ $t('app.topbar.spaces') }}</span>
        <ContextHandler contextType="space" />
      </div>
      <div v-if="!!appStore.currentCampaignId" class="inline">
        <span>|</span>
        <span class="context-title">{{ $t('app.topbar.campaigns') }}</span>
        <ContextHandler contextType="campaign" />
      </div>
    </div>
    <div data-step="credits" class="topbar-item align-right" v-tooltip="$t('app.home.creditsLeft', { count: credits?.available ?? 0 })">
      <p class="credit-title">{{ $t('app.topbar.credits') }}</p>
      <div class="credit-wrapper">

        {{ credits?.available ?? 0 }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ContextHandler from '@/components/topbar/ContextHandler.vue';
import { useOrganisationCredits } from '@/queries/organisation.query';

const router = useRouter();
const route = useRoute();
const appStore = useAppStore();

const { data: credits } = useOrganisationCredits();

const state = reactive<{
  search: string,
}>({
  search: "",
});

</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.topbar-wrapper {
  display: flex;
  gap: 12px;
  align-items: center;

  background-color: var(--white-color);
  border-bottom: 1px solid var(--light-grey-color);
  padding: 8px 14px;
  height: 3rem;

  .topbar-item {
    display: flex;
    align-items: center;
    gap: 12px;
    height: 100%;

    &.align-right {
      margin-left: auto;
    }
  }

  .context-title {
    font-size: 12px;
    font-weight: 600;
    color: $secondary-200-color;
  }

  .context-separator {
    padding: 0 0px;
  }
}

.credit-title {
  font-size: 14px;
}

.credit-wrapper {
  border-radius: 4px;
  padding: 2px 8px;
  background-color: $primary-color;
  color: black;
}

.link {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;

  font-size: 14px;
  cursor: pointer;
}

.inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search {
  height: 32px;
  width: 300px;
}


</style>